'use strict';

// AssetType workspace (#/AssetType/Workspace/:ID[/:Tab]) — unifies the asset type's former three screens
// (the master list, the retired flat manifest editor, and the metadata-shape editor) into one tabbed page.
// Overview edits Name/Description; the Metadata Shape tab embeds the AssetTypeDescriptor editor (now both
// an authoring and a display-tailoring surface) scoped to this type. See [[AssetTypeWorkspace-Provider.js]].

const libAssetTypeWorkspaceProvider = require('../providers/AssetTypeWorkspace-Provider.js');

module.exports = {
	Identifier: 'AssetTypeWorkspace',
	Ordinal: 31,
	ProviderClass: libAssetTypeWorkspaceProvider,
	Entity: { Name: 'AssetType', IDField: 'IDAssetType', Collection: 'AssetTypes', GUIDField: 'GUIDAssetType' },
	RoutePrefix: 'AssetType',
	Header:
	{
		Eyebrow: 'Asset Type',
		Title: (pRec) => pRec.Name || `#${ pRec.IDAssetType }`,
		Subtitle: (pRec) => pRec.Description || '',
		ListRoute: '#/PSRS/AssetType/List',
	},
	// The generic PSRS Edit link opens the workspace (identical to Asset.config.js — harmless without EditContent).
	Edit: { Route: 'workspace' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'render', ref: '_overviewHTML' } },
		{ Key: 'metadata', Label: 'Metadata Shape', Icon: 'fas fa-sliders', Content: { kind: 'embed', ref: 'AssetTypeDescriptor', style: 'provider' } },
	],
	CSSExtra: /*css*/`
		.atw-form { display:flex; flex-direction:column; gap:0.9rem; max-width:40rem; }
		.atw-field { display:flex; flex-direction:column; gap:0.25rem; }
		.atw-label { font-size:0.68rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		.atw-in { font-size:0.9rem; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-medium,#c7cfda); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.atw-ta { min-height:5rem; resize:vertical; font-family:inherit; }
		.atw-actions { display:flex; gap:0.6rem; align-items:center; margin-top:0.3rem; }
		.atw-btn { font-size:0.86rem; font-weight:600; padding:0.45rem 1rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#2e7d74); background:var(--theme-color-brand-primary,#2e7d74); color:#fff; cursor:pointer; }
		.atw-btn[disabled] { opacity:0.55; cursor:default; }
		.atw-msg { font-size:0.85rem; color:#1b6e3a; margin:0 0 0.6rem; }
		.atw-err { font-size:0.85rem; color:var(--theme-color-status-error,#b3382f); margin:0 0 0.6rem; }
		.atw-hint { font-size:0.8rem; color:var(--theme-color-text-muted,#8894a4); }
		.atw-note { margin-top:1.1rem; font-size:0.83rem; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-secondary,#eef1f6); border-radius:7px; padding:0.55rem 0.7rem; }
	`,
};
